import { IonTitle } from '@ionic/react';
import styled from 'styled-components';

export const ChatsTitle = styled.h1`
  font-weight: 600 !important;
  font-size: 28px !important;
  line-height: 40px !important;
  color: #1d201f;
`;

export const EmptyWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 55px;
`;

export const RoomsWrapper = styled.div``;

export const RoomsContentWrapper = styled.div`
  margin-top: 20px;

  & ion-spinner {
    width: 40px;
    height: 40px;
    color: #177590;
  }

  & .infinite-loading {
    margin-top: 24px;
  }
`;

export const NoConnectWrapper = styled.div`
  position: absolute;
  z-index: 100;
  width: 343px;
  left: 50%;
  top: 16px;
  transform: translateX(-50%);
`;

export const HeaderLoader = styled(IonTitle)`
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
  --color: #1d201f;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 12px;
  }
`;
